module.exports = __webpack_public_path__ + "img/sction2.37d77dcd.jpg";